<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
<!--            <v-flex xs12>-->
<!--              <v-text-field-->
<!--                  type="text"-->
<!--                  :label="$t('Mã chương trình')"-->
<!--                  v-model.trim="item.programCode"-->
<!--                  name="programCode"-->
<!--                  v-validate="'required'"-->
<!--                  maxLength="250"-->
<!--                  :error-messages="errors.first('programCode')"-->
<!--                  :data-vv-as="$t('Mã khung chương trình')"-->
<!--                  disabled-->
<!--              ></v-text-field>-->
<!--            </v-flex>-->
<!--            <v-flex xs12>-->
<!--              <v-text-field-->
<!--                  type="text"-->
<!--                  :label="$t('Mã chương trình')"-->
<!--                  v-model.trim="item.programCode"-->
<!--                  name="programCode"-->
<!--                  v-validate="'required'"-->
<!--                  maxLength="250"-->
<!--                  :error-messages="errors.first('programCode')"-->
<!--                  :data-vv-as="$t('Mã chương trình')"-->
<!--              ></v-text-field>-->
<!--            </v-flex>-->
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên chương trình')"
                  v-model.trim="item.programName"
                  name="programName"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('programName')"
                  :data-vv-as="$t('Tên chương trình')"
              ></v-text-field>
            </v-flex>
<!--            <v-flex xs12>-->
<!--              <v-text-field-->
<!--                  type="text"-->
<!--                  :label="$t('Mô tả')"-->
<!--                  v-model.trim="item.description"-->
<!--                  name="description"-->
<!--                  v-validate="'required'"-->
<!--                  maxLength="250"-->
<!--                  :error-messages="errors.first('description')"-->
<!--                  :data-vv-as="$t('Mô tả')"-->
<!--              ></v-text-field>-->
<!--            </v-flex>-->
<!--            <v-flex xs12>-->
<!--              <v-text-field-->
<!--                  type="text"-->
<!--                  :label="$t('Level')"-->
<!--                  v-model.trim="item.levelId"-->
<!--                  name="levelId"-->
<!--                  v-validate="'required'"-->
<!--                  maxLength="250"-->
<!--                  :error-messages="errors.first('levelId')"-->
<!--                  :data-vv-as="$t('Level')"-->
<!--              ></v-text-field>-->
<!--            </v-flex>-->
            <v-flex xs12>
            <v-select
                :items="levels"
                :label="$t('Level')"
                v-model="item.levelId"
                name="levelId"
                item-value="levelId"
                item-text="levelNumber"
                v-validate="'required'"
                :data-vv-as="$t('Level')"
                :error-messages="errors.first('levelId')"
                :disabled="item.pondId ? true : false"
                v-on:change="levelChange(item.levelId)"
            />
          </v-flex>
            <v-flex xs12>
              <v-select
                  :items="ages"
                  :label="$t('Độ tuổi')"
                  v-model="item.ageId"
                  name="ageId"
                  item-value="ageId"
                  item-text="ageName"
                  v-validate="'required'"
                  :data-vv-as="$t('Độ tuổi')"
                  :error-messages="errors.first('ageId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.ageId)"
              />
            </v-flex>

            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Số tuần học')"
                  v-model.trim="item.weekTotal"
                  name="weekTotal"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('weekTotal')"
                  :data-vv-as="$t('Số tuần học')"
              ></v-text-field>
            </v-flex>
<!--            <v-flex xs12>-->
<!--              <v-select-->
<!--                  :items="areaStatus"-->
<!--                  :label="$t('Trạng thái')"-->
<!--                  v-model="item.status"-->
<!--                  name="status"-->
<!--                  item-value="value"-->
<!--                  item-text="text"-->
<!--                  :data-vv-as="$t('Trạng thái')"-->
<!--                  :error-messages="errors.first('status')"-->
<!--              />-->
<!--            </v-flex>-->
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    levels: {
      type: Array,
      default: [],
    },

    ages: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        programName: "",
        weekTotal: "",
        levelId: "",
        ageId: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            programId: value.programId,
            programName: value.programName
                ? value.programName
                : "",
            weekTotal: value.weekTotal
                ? value.weekTotal
                : "",
            levelId: value.levelId
                ? value.levelId
                : "",
            ageId: value.ageId
                ? value.ageId
                : "",
            status: value.status ? value.status : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        programName: "",
        weekTotal: "",
        levelId: "",
        ageId: "",
      };
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidProgram/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    // kidLevel
    axios.post(
        process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.levels = data;
              }
            }
        );

    // kidAge
    axios.post(
        process.env.VUE_APP_API_URL + "/kidAge/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.ages = data;
              }
            }
        );

  },
};
</script>
